score = document.getElementById('score')

function addSymbolToTable(symbol, pressedKey) {
    console.log('adding symbol to table...; pressed key: ' + pressedKey)

    var symbolMiniature = document.createElement('img')
    symbolMiniature.src = symbol.img
    symbolMiniature.className = 'symbolMiniature'

    var newRow = document.createElement('tr')
    var symbolCell = document.createElement('td')
    var evaluationCell = document.createElement('td')
    var roundCell = document.createElement('td')
    
    // get number of rows in table
    var rowCount = symbolsTable.rows.length
    console.log('rowCount: ' + rowCount)

    if (rowCount > 10) {
        symbolsTable.deleteRow(1)
        
        
    }
    
    var expectedAnswerCell = document.createElement('td')
    if (symbol.shouldBeSelected) { 
        expectedAnswerCell.innerHTML = 'a'
    } else {
        expectedAnswerCell.innerHTML = 'i'
    }
    
    
    var yourAnswerCell = document.createElement('td')
    
    yourAnswerCell.innerHTML = pressedKey

    if (pressedKey == null) {
        yourAnswerCell.innerHTML = '-'
    }

    if (pressedKey == expectedAnswerCell.innerHTML) {
        evaluationCell.style.color = 'green'
        evaluationCell.innerHTML = 'Richtig'
        score += 1
    } else {
        evaluationCell.style.color = 'red'
        evaluationCell.innerHTML = 'Falsch'
        faults +=1
    }


    roundCell.innerHTML = round
    round += 1
    scoreDiv.innerHTML = 'Punkte: ' + score 


    
    symbolCell.appendChild(symbolMiniature)
    newRow.appendChild(roundCell)
    newRow.appendChild(symbolCell)
    newRow.appendChild(expectedAnswerCell)
    newRow.appendChild(yourAnswerCell)
    newRow.appendChild(evaluationCell)
    symbolsTable.appendChild(newRow)

    
}
